import TextWidgetModel from './text-widget-model'
import _ from 'lodash'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import i18n from 'scoreboard/components/i18n'

export default function (bootslideMenu) {
	var label = 'dashboards.dashboard.text'
	return {
		label: i18n.get(label),
		content: option('add-widget-text', label),
		target: _.bind(function (e) {
			var widget = new TextWidgetModel(
				{
					properties: {
						type: 'text',
						text: '',
						background: 'none'
					}
				})

			createWob(bootslideMenu.canvas, widget, { fetchData: false }, bootslideMenu)

			var wobView = _(bootslideMenu.canvas.views).values().find(function (wobView) {
				return wobView.model.widget.cid === widget.cid
			})

			wobView.view.state('selected')

			e.preventDefault()
			e.stopPropagation()

			this.trigger('done')
		}, bootslideMenu)
	}
}
